import { render, staticRenderFns } from "./AddUpdateBranch.vue?vue&type=template&id=287ff659"
import script from "./AddUpdateBranch.vue?vue&type=script&lang=js"
export * from "./AddUpdateBranch.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateBranch.vue?vue&type=style&index=0&id=287ff659&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports